export const OPEN_DRAWER = '@DRAWER/OPEN';
export const CLOSE_DRAWER = '@DRAWER/CLOSE';

export const actionCreators = {
    openDrawer: () =>  ({ type: OPEN_DRAWER }),
    closeDrawer: () =>  ({ type: CLOSE_DRAWER }),
};
